import { useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import { RawFiles } from './RawFiles.jsx';
import { DownloadLink } from './DownloadLink.jsx';
import { Boundaries } from './Boundaries.jsx';
import { Spinner } from '../../../components/Spinner.jsx';

export function DetailPanel({ row, getRawFiles }) {
  const [rawFiles, setRawFiles] = useState();

  useEffect(() => {
    getRawFiles(row.id).then(setRawFiles);
  }, [getRawFiles, row.id]);

  return (
    <Box sx={{ p: 3, bgcolor: 'grey.300' }}>
      {rawFiles ? buildDetails() : <Spinner />}
    </Box>
  );

  function buildDetails() {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper sx={{ px: 2 }}>
          {row.agi?.file ? (
            <Box>
              <DownloadLink
                url={row.agi.file}
                displayName="Download AGI raw files"
              />
            </Box>
          ) : null}
          {row.leaf?.file ? (
            <Box>
              <DownloadLink
                url={row.leaf.file}
                displayName="Download Leaf raw files"
              />
            </Box>
          ) : null}
        </Paper>
        <Paper>
          <Boundaries rawFiles={rawFiles} />
        </Paper>
        <Paper>
          <RawFiles rawFiles={rawFiles} />
        </Paper>
      </Box>
    );
  }
}
